import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

import {
  handoffHint,
  handoffNavState,
  type EditorHandoff,
} from "@/shared/lib/advisorHandoff";

/**
 * PC 交接卡(ADV-HANDOFF-PC-1,2026-08-18 P1)。
 *
 * ★补的是**跨端功能缺口**,不是新功能:ai 侧 handoff_to_editor 一直在发 ui_action、
 * H5 一直渲染得好好的,只有 PC console 把这类 action 静默丢了 —— 军师嘴上说「给你交接卡」
 * 而屏幕上什么也没有(老板实报)。所以解析器/state 构造/副标文案全部复用 shared 那份,
 * 这里只负责 PC 的样子。
 *
 * ★REDIRECT 红线不动:卡是**带路**不是代做 —— 点它只把军师收齐的料带进编辑页,
 * 出图/出片仍由用户在那页自己下单。
 */
export function HandoffRow({ handoffs }: { handoffs: EditorHandoff[] }) {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col gap-1.5" data-testid="advisor-handoffs">
      {handoffs.map((h) => (
        <button
          key={h.capabilityId}
          type="button"
          data-testid={`advisor-handoff-${h.capabilityId}`}
          onClick={() => navigate(h.route, { state: handoffNavState(h) })}
          className="group flex items-center gap-2 rounded-lg border border-primary/30 bg-primary/5 px-3 py-2 text-left transition-colors hover:border-primary/60 hover:bg-primary/10"
        >
          <span className="min-w-0 flex-1">
            <span className="block truncate text-sm font-medium text-foreground">{h.title}</span>
            <span className="block text-2xs text-muted-foreground">{handoffHint(h)}</span>
          </span>
          <span className="flex shrink-0 items-center gap-1 text-xs text-primary">
            去编辑页
            <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
          </span>
        </button>
      ))}
    </div>
  );
}
